/**
 * Format a date into something nice looking
 * @param {Date} date Date to format
 * @param {String} format Desired output format
 * @return {String} Formatted date
 */
export default function (date, format) {
  if (!date || typeof date.getMonth !== 'function') {
    return date
  }

  const options = {
    date: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    },
    'long-month': {
      year: 'numeric',
      month: 'long'
    },
    time: {
      hour: '2-digit',
      minute: '2-digit'
    }
  }

  options['date-time'] = {
    ...options.date,
    ...options.time
  }

  // Set default if format isn’t available or not set at all
  const option = options[format] || options.date

  return date.toLocaleString('de-DE', option)
}
